import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {ProjectService} from "../../project/project.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "./edit-shipping-labels.template.pug",
  providers: [
    ProjectService,
  ],
})
export class EditShippingLabelsComponent extends WorkflowStep {
  currentFocus: string = "shippingLabel1";
  error: Error;

  shippingLabel1: string;
  shippingLabel2: string;
  originalShippingLabel1: string;
  originalShippingLabel2: string;
  isMigrationActive: boolean = false;
  placeholders = [
    {
      name: "{FirstName}",
      description: "First name of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{LastName}",
      description: "Last name of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{MailStop}",
      description: "Mail stop of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{EmailAddress}",
      description: "Email address of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{PhoneNumber}",
      description: "Primary phone number of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{PhoneNumber2}",
      description: "Secondary phone number of the contact for consumables that is the closest to the asset",
    },
    {
      name: "{DeptName}",
      description: "Department name",
    },
    {
      name: "{LocationGrid}",
      description: "Location grid where the device is located",
    },
    {
      name: "{LocationNotes}",
      description: "Additional notes for device location",
    },
    {
      name: "{AreaName}",
      description: "Area name of the group owning the device",
    },
    {
      name: "{GroupName}",
      description: "Name of the group owning the device",
    },
    {
      name: "{SiteName}",
      description: "Name of the customer site where the device is located",
    },
    {
      name: "{BuildingName}",
      description: "Name of the building where the device is located",
    },
    {
      name: "{LevelName}",
      description: "Name of the level where the device is located",
    },
    {
      name: "{ModelName}",
      description: "Model name of the device",
    },
    {
      name: "{FamilyName}",
      description: "Family name of the device",
    },
    {
      name: "{ProductNumber}",
      description: "Product number of the device",
    },
    {
      name: "{ManufacturerName}",
      description: "Name of the manufacturer of the device",
    },
    {
      name: "{AssetNumber}",
      description: "Asset number of the device",
    },
    {
      name: "{SerialNumber}",
      description: "Serial number of the device",
    },
    {
      name: "{HostName}",
      description: "Hostname of the device",
    },
    {
      name: "{IPAddress}",
      description: "IP address of the device",
    },
    {
      name: "{PortNumber}",
      description: "Port number of the device",
    },
    {
      name: "{CommentText}",
      description: "Comments about the device",
    },
    {
      name: "{Custom1}",
      description: "Custom field 1 value of the asset",
    },
    {
      name: "{Custom2}",
      description: "Custom field 2 value of the asset",
    },
    {
      name: "{Custom3}",
      description: "Custom field 3 value of the asset",
    },
    {
      name: "{Custom4}",
      description: "Custom field 4 value of the asset",
    },
    {
      name: "{Custom5}",
      description: "Custom field 5 value of the asset",
    },
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public projectService: ProjectService,
  ) {
    super();
  }

  async ready() {
    this.loadProjectInfo();
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.projectService.saveShippingLabels(
      this.workflowTargetInfo.projectId,
      this.shippingLabel1,
      this.shippingLabel2,
    );

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  @toggleLoading()
  async loadProjectInfo() {
    const {
      customShippingLabel1,
      customShippingLabel2,
      isMigrationActive = false,
    } = await this.projectService.getShippingLabels(this.workflowService.workflowConfig.projectId);
    this.shippingLabel1 = customShippingLabel1;
    this.shippingLabel2 = customShippingLabel2;
    this.isMigrationActive = isMigrationActive;
    this.originalShippingLabel1 = customShippingLabel1;
    this.originalShippingLabel2 = customShippingLabel2;
  }

  checkDirty(): boolean {
    return !(this.shippingLabel1 === this.originalShippingLabel1) ||
      !(this.shippingLabel2 === this.originalShippingLabel2);
  }

  addPlaceholder(placeholder) {
    if (this.currentFocus === "shippingLabel1") {
      this.shippingLabel1 = `${this.shippingLabel1 || ""}${placeholder}`;
    } else if (this.currentFocus === "shippingLabel2") {
      this.shippingLabel2 = `${this.shippingLabel2 || ""}${placeholder}`;
    }
  }

  onFocus(parameter) {
    this.currentFocus = parameter;
  }
}
